import React, { useEffect } from 'react';
import { datadogRum } from '@datadog/browser-rum';
import { AnalyticEvents } from '@constants/index';
import { Analytics } from '@services/analytics-service';
import { useSnapshot } from 'valtio';
import { SarStore } from '@store/sar-store';
import { ImageUpload as ImageUploadComponent } from '../../components/upload/upload';
import { useRouter, ROUTES } from '../../providers/router';
import { useUserSelections } from '../../providers/user-selections';
import { Category } from '../../constants';

export const ImageUpload = () => {
  const { completeFormStep } = useRouter();
  const { userSelections } = useUserSelections();
  const { isTreatment } = useSnapshot(SarStore.cosmeticVehicleConcernExperiment);
  const isCosmeticCategory = userSelections.category === Category.Cosmetic;
  const showDetailsField = isCosmeticCategory && isTreatment;

  useEffect(() => {
    Analytics.trackEvent(AnalyticEvents.sarCosmeticViewed);
    datadogRum.addAction(AnalyticEvents.sarCosmeticViewed);

    if (showDetailsField) {
      Analytics.trackEvent(AnalyticEvents.vehicleConcernDetailsCosmeticViewed);
      datadogRum.addAction(AnalyticEvents.vehicleConcernDetailsCosmeticViewed);
    }
  }, [showDetailsField]);

  const handleNextRoute = () => {
    completeFormStep(ROUTES.IMAGE_UPLOAD);
  };

  return <ImageUploadComponent handleNextRoute={handleNextRoute} showDetailsField={showDetailsField} />;
};

export default ImageUpload;
